module.exports = __webpack_public_path__ + "img/1A_old.82eee06c.jpg";